import { Component } from '@angular/core';

@Component({
  selector: 'app-alert-showcase',
  templateUrl: './alert-showcase.component.html',
  styleUrls: ['./alert-showcase.component.scss']
})
export class AlertShowcaseComponent {
  dismissedAlerts: Set<string> = new Set();

  onDismissed(alertName: string): void {
    this.dismissedAlerts.add(alertName);
    console.log(`Alert dismissed: ${alertName}`);
  }

  resetAlerts(): void {
    this.dismissedAlerts.clear();
    console.log('All alerts reset');
  }

  isAlertDismissed(alertName: string): boolean {
    return this.dismissedAlerts.has(alertName);
  }
}
